import {MappedStammdatenBerater, TaskDataService, WizardPageBaseComponent} from '@utils-lib';
import {Component, OnInit} from '@angular/core';
import {EmpfangsbevollmaechtigterAngaben, PersonenTypEnumLabels, SteuerlicheBeratungAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-lib-steuerliche-beratung-angaben',
    templateUrl: './steuerliche-beratung-angaben.component.html'
})
export class SteuerlicheBeratungAngabenComponent extends WizardPageBaseComponent<SteuerlicheBeratungAngaben> implements OnInit {

    static nutzdatenPath = 'steuerlicheBeratungAngaben';
    static route = 'steuerliche-beratung-angaben';

    public personenTypEnum = PersonenTypEnumLabels;
    public requiredSteuerberater = true;

    constructor(protected readonly activatedRoute: ActivatedRoute, private readonly taskDataService: TaskDataService) {
        super(activatedRoute);
    }

    public get requiredEmptySteuerberater(): boolean {
        const hasFirmenname = (this.data.personenTyp === PersonenTypEnumLabels.NNatPers && this.data.juristischePerson?.firmenname);
        const hasNachname = (this.data.personenTyp === PersonenTypEnumLabels.NatPers && this.data.natuerlichePerson?.nachname);
        return this.requiredSteuerberater && !(hasFirmenname || hasNachname);
    }

    public ngOnInit(): void {
        super.ngOnInit();

        const empfangsbevollmaechtigter =
            this.taskDataService.getNutzdaten('empfangsbevollmaechtigterAngaben') as EmpfangsbevollmaechtigterAngaben;
        this.requiredSteuerberater = empfangsbevollmaechtigter.steuerberaterVollmacht;
    }

    public onBeraterPicked(mappedBerater: MappedStammdatenBerater): void {
        this.data.personenTyp = mappedBerater.personenTyp;
        if (mappedBerater.personenTyp === PersonenTypEnumLabels.NatPers) {
            this.data.natuerlichePerson = mappedBerater.natuerlichePerson;
        }
        if (mappedBerater.personenTyp === PersonenTypEnumLabels.NNatPers) {
            this.data.juristischePerson = mappedBerater.juristischePerson;
        }
    }

    public clearSteuerlicheBeratung($event): void {
        if ($event === PersonenTypEnumLabels.NatPers) {
            this.data.juristischePerson = null;
        } else if ($event === PersonenTypEnumLabels.NNatPers) {
            this.data.natuerlichePerson = null;
        } else {
            this.data.juristischePerson = null;
            this.data.natuerlichePerson = null;
            this.data.inlandsadresse = null;
            this.data.auslandsadresse = null;
            this.data.postfachadresse = null;
            this.data.kommunikationsmittel = null;
        }
    }

    protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
        return new Map<string, unknown | Array<unknown>>([
            ['personenTyp', this.stammdaten?.berater?.personenTyp],
            ['natuerlichePerson', this.stammdaten?.berater?.natuerlichePerson],
            ['juristischePerson', this.stammdaten?.berater?.juristischePerson],
            ['inlandsadresse', this.stammdaten?.berater?.inlandsadressen],
            ['auslandsadresse', this.stammdaten?.berater?.auslandsadressen],
            ['postfachadresse', this.stammdaten?.berater?.postfachadressen],
            ['kommunikationsmittel.telefonnummern[0]', this.stammdaten?.berater?.kommunikation?.telefonnummern],
        ]);
    }
}
